var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "试卷信息预览",
            visible: _vm.dialogVisible,
            width: "900px",
            "custom-class": "no-padding full-height",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "infinite-scroll",
                  rawName: "v-infinite-scroll",
                  value: _vm.getQuestions,
                  expression: "getQuestions"
                }
              ],
              staticClass: "paper-content",
              attrs: {
                "infinite-scroll-distance": 100,
                "infinite-scroll-disabled": _vm.finished || _vm.loading,
                "infinite-scroll-immediate": "false"
              }
            },
            [
              _c("div", { staticClass: "inner-content" }, [
                _c(
                  "div",
                  { staticClass: "top-info", attrs: { id: "top_info" } },
                  [
                    _c("div", { staticClass: "fx-1" }, [
                      _c("ul", { staticClass: "paper-details" }, [
                        _c("li", { staticClass: "block" }, [
                          _c("div", { staticClass: "key" }, [
                            _vm._v("试卷名称：")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "value",
                              staticStyle: { color: "#04ADC0" }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.details.name) +
                                  "\n                "
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.details.subjectCatalogueName ||
                        _vm.details.testPaperGroupName
                          ? _c("li", [
                              _c("div", { staticClass: "key" }, [
                                _vm._v("课程/归属：")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.details.subjectCatalogueName ||
                                      _vm.details.testPaperGroupName
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "key" }, [
                            _vm._v("试卷级别：")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _vm._v(
                              _vm._s(_vm._f("paperLevel")(_vm.details.level)) +
                                "试卷"
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c("div", { staticClass: "key" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "value" }, [
                            _c("span", [
                              _vm._v("试卷共"),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    margin: "0 5px",
                                    color: "#04ADC0"
                                  }
                                },
                                [_vm._v(_vm._s(_vm.details.questionNumber))]
                              ),
                              _vm._v("道题，")
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              [
                                _vm._v("\n                    整体难度"),
                                _c("el-rate", {
                                  staticStyle: {
                                    display: "inline-block",
                                    "vertical-align": "middle",
                                    "margin-left": "5px"
                                  },
                                  attrs: {
                                    disabled: "",
                                    "text-color": "#ff9900",
                                    "disabled-void-color": "#ccc"
                                  },
                                  model: {
                                    value: _vm.details.difficulty,
                                    callback: function($$v) {
                                      _vm.$set(_vm.details, "difficulty", $$v)
                                    },
                                    expression: "details.difficulty"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.details.mode
                          ? _c("li", [
                              _c("div", { staticClass: "key" }, [
                                _vm._v("随机题量：")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.details.examQuestionCount))
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.details.mode == 1
                          ? _c("li", [
                              _c("div", { staticClass: "key" }, [
                                _vm._v("随机难度系数：")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(
                                  _vm._s(_vm.details.difficultyCoefficient)
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.details.mode == 2
                          ? _c("li", [
                              _c("div", { staticClass: "key" }, [
                                _vm._v("随机题型：")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _c("span", [
                                  _vm._v(
                                    "单选题(" +
                                      _vm._s(
                                        _vm.details.radioQuestionProportion
                                      ) +
                                      ")  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "多选题(" +
                                      _vm._s(_vm.details.mcQuestionProportion) +
                                      ")  "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "判断题(" +
                                      _vm._s(
                                        _vm.details.torFQuestionProportion
                                      ) +
                                      ")  "
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.details.label
                          ? _c("li", [
                              _c("div", { staticClass: "key" }, [
                                _vm._v("标签：")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "value" }, [
                                _vm._v(_vm._s(_vm.details.label))
                              ])
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.details.description
                        ? _c("div", [
                            _c("p", { staticClass: "color-999" }, [
                              _vm._v(_vm._s(_vm.details.description))
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.details.questionTypeNumber &&
                      _vm.details.questionTypeNumber.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "question-details",
                              class: {
                                flex:
                                  _vm.details.questionTypeNumber &&
                                  _vm.details.questionTypeNumber.length > 3
                              }
                            },
                            _vm._l(_vm.details.questionTypeNumber, function(
                              item
                            ) {
                              return _c(
                                "div",
                                {
                                  key: item.questionTypeTag,
                                  staticClass: "items",
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.scrollPosition(
                                        "tag_" + item.questionTypeTag,
                                        "start"
                                      )
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    [
                                      _vm._v(_vm._s(item.questionTypeTag)),
                                      _c(
                                        "b",
                                        {
                                          staticStyle: {
                                            margin: "0 2px",
                                            "font-weight": "normal"
                                          }
                                        },
                                        [_vm._v(_vm._s(item.number))]
                                      ),
                                      _vm._v("题（"),
                                      _vm._l(item.list, function(s) {
                                        return [
                                          s.count
                                            ? _c(
                                                "span",
                                                { key: s.difficulty },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("capitalNumber")(
                                                        s.difficulty
                                                      )
                                                    ) +
                                                      "星:" +
                                                      _vm._s(s.count)
                                                  )
                                                ]
                                              )
                                            : _vm._e()
                                        ]
                                      }),
                                      _vm._v("）")
                                    ],
                                    2
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.details.qrUrl
                      ? _c(
                          "div",
                          { staticClass: "code" },
                          [
                            _c("qr-code", {
                              attrs: { text: _vm.details.qrUrl, size: 180 }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "mt-5 text-center" }, [
                              _vm._v("试卷资源码")
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "question-list" },
                  _vm._l(_vm.dataList, function(item, order) {
                    return _c(
                      "div",
                      {
                        key: item.id,
                        staticClass: "tag-item",
                        attrs: { id: "tag_" + item.tagName }
                      },
                      [
                        item.tagName
                          ? _c("h4", [
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.func.capitalNumber(order + 1)) +
                                    "、" +
                                    _vm._s(item.tagName) +
                                    "（共"
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { margin: "0 2px" } },
                                  [_vm._v(_vm._s(item.children.length))]
                                ),
                                _vm._v("题）")
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(item.children, function(data, index) {
                          return _c("single-question", {
                            key: index,
                            attrs: {
                              data: data.question,
                              index: index + 1,
                              deleteMode: "custom"
                            },
                            on: { callback: _vm.editPaperQuestion }
                          })
                        })
                      ],
                      2
                    )
                  }),
                  0
                )
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "to-top",
              attrs: { type: "info", circle: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.scrollPosition("top_info")
                }
              }
            },
            [_c("span", { staticClass: "iconfont icon-fanhuidingbu font-18" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.slotBtns
                ? _vm._t("btns")
                : [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            _vm.dialogVisible = false
                          }
                        }
                      },
                      [_vm._v("关闭")]
                    ),
                    _vm._v(" "),
                    _vm.isDownload
                      ? _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.download }
                          },
                          [_vm._v("导出题目")]
                        )
                      : _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                _vm.dialogVisible = false
                              }
                            }
                          },
                          [_vm._v("确定")]
                        )
                  ]
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("question-edit-model", {
        attrs: { data: _vm.question, type: _vm.type },
        on: { callback: _vm.editPaperQuestion },
        model: {
          value: _vm.questionVisible,
          callback: function($$v) {
            _vm.questionVisible = $$v
          },
          expression: "questionVisible"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22fefc5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22fefc5e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PaperView.vue
// module id = 581
// module chunks = 14